export const actionCreate = (actionType, payload) => ({
  type: actionType,
  ...payload,
});
